import { computed, ComputedRef } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { ParametersDescription } from '../../domain/ParametersDescription'
import { SectionName } from '../../domain/SectionName'

export const useTransversalParameters = (): ComputedRef<ParametersDescription>[] => {
  const i18n = useI18nForVue2()
  return [
    computed(() => ({
      title: `${i18n.t('ctx.parameters.transversal__import-history__title')}`,
      description: `${i18n.t('ctx.parameters.transversal__import-history__description')}`,
      route: 'import-reports',
      icon: 'clock-outlined',
      section: SectionName.Transversal,
    })),
  ]
}
